import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcOrganizationSwitcher = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 14a1 1 0 0 1 1 1v2h8a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-2h-7v2a1 1 0 1 1-2 0v-2H4v2a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1h8v-2a1 1 0 0 1 1-1Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m13.06 11.06 1.233 1.233a1 1 0 0 0 1.414 0l3.586-3.586a1 1 0 0 0 0-1.414l-3.586-3.586a1 1 0 0 0-1.414 0L13.06 4.939l1.292 1.293c.041.04.08.083.118.125l.53-.528L17.172 8 15 10.17l-.53-.529a2.545 2.545 0 0 1-.117.126L13.06 11.06Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.293 3.707a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-3.586 3.586a1 1 0 0 1-1.414 0L4.707 8.707a1 1 0 0 1 0-1.414l3.586-3.586Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcOrganizationSwitcher");

export { IcOrganizationSwitcher };
//# sourceMappingURL=ic-organization-switcher.js.map
